import { STORAGE_KEYS } from '../constants/storageKeys';

export const saveToLocalStorage = (key: string, value: unknown): void => {
    if (!key || typeof key !== 'string') {
        throw new Error('Invalid key')
    }

    if (typeof value === 'object') {
        localStorage.setItem(key, JSON.stringify(value))
    } else {
        localStorage.setItem(key, String(value))
    }
}

export const readFromLocalStorage = (key: string): unknown => {
    if (!key || typeof key !== 'string') {
        throw new Error('Invalid key')
    }

    try {
        return JSON.parse(localStorage.getItem(key)!)
    } catch {
        return localStorage.getItem(key)
    }
}

export const removeFromLocalStorage = (key: string): void => {
    localStorage.removeItem(key);
}

export function getCurrentLanguage(): string | null {
    return localStorage.getItem(STORAGE_KEYS.CURRENT_LANGUAGE);
}

export function setCurrentLanguage(code: string): void {
    localStorage.setItem(STORAGE_KEYS.CURRENT_LANGUAGE, code);
}

export function removeCurrentLanguage(): void {
    localStorage.removeItem(STORAGE_KEYS.CURRENT_LANGUAGE);
}

export function getLegacyLanguage(): string | null {
    return localStorage.getItem(STORAGE_KEYS.LEGACY_LANGUAGE);
}

export function removeLegacyLanguage(): void {
    localStorage.removeItem(STORAGE_KEYS.LEGACY_LANGUAGE);
}

export function removeLegacyDirection(): void {
    localStorage.removeItem(STORAGE_KEYS.LEGACY_DIRECTION);
}

export function getVideoType(): string | null {
    return localStorage.getItem(STORAGE_KEYS.VIDEO_TYPE);
}

export function setVideoType(type: string): void {
    localStorage.setItem(STORAGE_KEYS.VIDEO_TYPE, type);
}

export function getGateMode(slug: string): string | null {
    return localStorage.getItem(`${STORAGE_KEYS.GATE_MODE_PREFIX}${slug}`);
}

export function setGateMode(slug: string, mode: string): void {
    localStorage.setItem(`${STORAGE_KEYS.GATE_MODE_PREFIX}${slug}`, mode);
}

export function getLocationPermissions(): boolean {
    return localStorage.getItem(STORAGE_KEYS.LOCATION_PERMISSIONS) === 'true';
}

export function setLocationPermissions(): void {
    localStorage.setItem(STORAGE_KEYS.LOCATION_PERMISSIONS, 'true');
}

export function removeLocationPermissions(): void {
    localStorage.removeItem(STORAGE_KEYS.LOCATION_PERMISSIONS);
}

export function removeTreeLevel(): void {
    localStorage.removeItem(STORAGE_KEYS.TREE_LEVEL);
}

export function getProgress(slug: string | undefined): Record<string, any> | null {
    const key = `${STORAGE_KEYS.PROGRESS_PREFIX}${slug}-progress`;
    const stored = localStorage.getItem(key);
    if (!stored) return null;
    try {
        return JSON.parse(stored);
    } catch {
        return null;
    }
}

export function setProgress(slug: string | undefined, data: Record<string, any>): void {
    const key = `${STORAGE_KEYS.PROGRESS_PREFIX}${slug}-progress`;
    localStorage.setItem(key, JSON.stringify(data));
}
